import { api } from "@services/baseURL";

export const SaveUnidadeGerencia = async (data) => {
  try {
    const response = await api.post('UnidadeGerencia', data);
    return response.data;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao salvar unidade/gerencia:', parsed);
    throw error;
  }
};

export const UpdateUnidadeGerencia = async (id, data) => {
  try {
    const response = await api.patch(`UnidadeGerencia/${id}`, data);
    return response.data;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao atualizar unidade/gerencia:', parsed);
    throw error;
  }
};

export const DeleteUnidadeGerencia = async (id) => {
  try {
    await api.delete(`UnidadeGerencia/${id}`);
    return true;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao deletar unidade/gerencia:', parsed);
    throw error;
  }
};

export const GetAllUnidadesGerencias = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('UnidadeGerencia', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao buscar todas unidades/gerencias:', parsed);
    throw error;
  }
};

export const GetByIdUnidadeGerencia = async (id) => {
  try {
    const response = await api.get('UnidadeGerencia', { "id:": id });
    return response.data;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao buscar unidade/gerencia:', parsed);
    throw error;
  }
};

export default {
  SaveUnidadeGerencia,
  UpdateUnidadeGerencia,
  DeleteUnidadeGerencia,
  GetByIdUnidadeGerencia,
  GetAllUnidadesGerencias
};